import React from 'react';
import { makeStyles } from '@mui/styles';
import { SatisfactionResponse } from '../../../components/surveys/surveys/client/SatisfactionResponse';
import { DecisionResponse } from '../../../components/surveys/surveys/client/DecisionResponse';
import { RecommendationResponse } from '../../../components/surveys/surveys/client/RecommendationResponse';
import { OpenMultilineResponse } from '../../../components/surveys/surveys/client/OpenMultilineResponse';
import { SelectResponse } from '../../../components/surveys/surveys/client/SelectResponse';
import { OpenLineResponse } from '../../../components/surveys/surveys/client/OpenLineResponse';
import { PqrsResponse } from '../../../components/surveys/surveys/client/PqrsResponse';

export const TypeResponse = (props) => {

    const { type, action, options } = props;
    const classes = useStyles();

    return (
        <div className={ classes.container }>
            { type.includes('satisfacción') && <SatisfactionResponse action={ action } options={ options } /> }
            { type.includes('decisión') && <DecisionResponse action={ action } options={ options }  /> }
            { type.includes('recomendación') && <RecommendationResponse action={ action } options={ options }  /> }
            { type.includes('selección') && <SelectResponse action={ action } options={ options } /> }
            { type === 'linea' && <OpenLineResponse action={ action } options={ options } /> }
            { type === 'multilinea' && <OpenMultilineResponse action={ action } options={ options } /> }
            { type === 'pqrs' && <PqrsResponse action={ action } options={ options } /> }
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        padding: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    }
});